export default {
  namespaced: true,
  state: {
    payrollRecords: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_PAYROLL(state, records) {
      state.payrollRecords = records
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchPayroll({ commit }) {
      try {
        commit('SET_LOADING', true)
        // API call would go here
        const records = [] // Replace with actual API call
        commit('SET_PAYROLL', records)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async generateMonthlyPayroll({ commit }) {
      try {
        commit('SET_LOADING', true)
        // API call to generate payroll would go here
        const records = [] // Replace with actual API call
        commit('SET_PAYROLL', records)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    getPayrollByEmployee: state => employeeId => {
      return state.payrollRecords.find(record => record.employeeId === employeeId)
    }
  }
} 